export default __webpack_public_path__ + "static/sky-background-01-3433396351c237a158edd4aec4d1c63e.png";